<template>
  <Card tag="form" class="residential-template-mutate-shop" @submit.prevent="$emit('submit')">
    <template #default>
      <Loader  :value="true" theme="default" />
    </template>
  </Card>
</template>

<script>
import { i18n } from '@/i18n'
import { mapState, mapActions } from 'vuex'

import Card from '@/components/Card'

const meta = {
  order: 3,
  id: 'shop',
  label: i18n.tc('addonShop'),
  icon: ['fal', 'shopping-cart'],
}

export { meta }
export default {
  props: {
    value: Object,
    labels: Object,
    validator: Object,
    isActive: Boolean,
    id: String,
  },
  watch: {
    isActive: {
      handler: 'prepare',
      immediate: true,
    },
    id: {
      handler: 'prepare',
      immediate: true,
    },
  },
  data() {
    return {
      isRedirecting: false,
    }
  },
  computed: {
    ...mapState('ResidentialTemplate', {
      shop: state => state.item.shop,
    }),
    ...mapState('Shop', ['promises']),
  },
  methods: {
    ...mapActions('Shop', {
      create(dispatch) {
        if (this.shop) return
        return dispatch('mutate', { reference: { onModel: 'ResidentialTemplate', ref: this.id } })
      },
    }),
    async prepare() {
      let redirect = id => {
        return this.$router.replace({ name: 'shop', params: { id } })
      }

      if (!this.isActive || !this.id || this.isRedirecting) return

      this.isRedirecting = true
      if (this.shop) return redirect(this.shop.id)

      return this.create().then(({ id }) => redirect(id))
    },
  },
  components: {
    Card,
  },
}
</script>

<style lang="scss">
.residential-template-mutate-shop {
  max-width: 900px;
}
</style>
